import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVulslang1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M8.496 24.868C7.1 22.223 6.34 18.796 6.34 15h3c0 3.424.69 6.347 1.809 8.467 1.11 2.105 2.567 3.298 4.107 3.634a3.92 3.92 0 0 0 3.569-1.453l2.35 1.864a6.92 6.92 0 0 1-6.383 2.553l-.048-.006-.047-.01c-2.703-.558-4.808-2.542-6.201-5.181"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M31.504 24.868c-1.393 2.639-3.498 4.623-6.2 5.181l-.048.01-.048.006a6.92 6.92 0 0 1-6.383-2.553l2.35-1.864a3.92 3.92 0 0 0 3.569 1.453c1.54-.336 2.996-1.53 4.107-3.634 1.119-2.12 1.809-5.043 1.809-8.467h3c0 3.796-.76 7.223-2.156 9.868"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M20 15.541a1.1 1.1 0 0 0-.969.58l-.04.076-.05.07a5.8 5.8 0 0 0-1.041 3.311 7.15 7.15 0 0 0 2.1 5.04 7.15 7.15 0 0 0 2.1-5.04 5.8 5.8 0 0 0-1.04-3.31l-.05-.071-.041-.077a1.1 1.1 0 0 0-.969-.579m0 11.039-.876 1.218a10.15 10.15 0 0 1-4.224-8.214v-.004c0-1.771.535-3.5 1.534-4.961a4.1 4.1 0 0 1 7.132 0A8.8 8.8 0 0 1 25.1 19.58v.004a10.15 10.15 0 0 1-4.224 8.214z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M10.24 13h-4.8v2.4h4.8z"
    />
    <path
      fill="#60D15D"
      d="M7.84 16.17a3.16 3.16 0 0 1-2.4-.79 3.17 3.17 0 0 1 2.4-.78 3.13 3.13 0 0 1 2.4.78 3.14 3.14 0 0 1-2.4.79"
    />
    <path
      fill="#B3E9B1"
      d="M7.84 14.86c2.21 0 4-.707 4-1.58s-1.79-1.58-4-1.58-4 .707-4 1.58 1.79 1.58 4 1.58"
    />
    <path
      fill="#B3E9B1"
      d="M11.84 10.89h-8v2.4h8z"
    />
    <path
      fill="#B3E9B1"
      d="M7.84 12.46c2.21 0 4-.707 4-1.58s-1.79-1.58-4-1.58-4 .707-4 1.58 1.79 1.58 4 1.58"
    />
    <path
      fill="#60D15D"
      d="M7.84 12.46c1.651 0 2.99-.461 2.99-1.03S9.491 10.4 7.84 10.4s-2.99.461-2.99 1.03 1.339 1.03 2.99 1.03M34.56 13h-4.8v2.4h4.8z"
    />
    <path
      fill="#60D15D"
      d="M32.16 16.17a3.14 3.14 0 0 1-2.4-.79 3.13 3.13 0 0 1 2.4-.78 3.17 3.17 0 0 1 2.4.78 3.16 3.16 0 0 1-2.4.79"
    />
    <path
      fill="#B3E9B1"
      d="M32.16 14.86c2.21 0 4-.707 4-1.58s-1.79-1.58-4-1.58-4 .707-4 1.58 1.79 1.58 4 1.58"
    />
    <path
      fill="#B3E9B1"
      d="M36.16 10.89h-8v2.4h8z"
    />
    <path
      fill="#B3E9B1"
      d="M32.16 12.46c2.21 0 4-.707 4-1.58s-1.79-1.58-4-1.58-4 .707-4 1.58 1.79 1.58 4 1.58"
    />
    <path
      fill="#60D15D"
      d="M32.16 12.46c1.651 0 2.99-.461 2.99-1.03s-1.339-1.03-2.99-1.03-2.99.461-2.99 1.03 1.339 1.03 2.99 1.03"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17.053 30.497 17 30l-.053-.497h.003l.025-.004.112-.018c.102-.02.255-.052.45-.106.392-.11.952-.305 1.604-.652 1.3-.69 2.98-1.984 4.43-4.4l.858.514c-1.55 2.584-3.37 4-4.82 4.77a9 9 0 0 1-1.803.73 6 6 0 0 1-.69.152l-.043.006-.013.001h-.005zM19.686 24.972a8.06 8.06 0 0 1-2.186-5.384l1-.016a7.06 7.06 0 0 0 1.914 4.716z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVulslang1);

export default ForwardRef;
